// extracted by mini-css-extract-plugin
export default {"container":"VideoSideToSide_container__LoRiy","normal":"VideoSideToSide_normal__rz+tu","video":"VideoSideToSide_video__Z5Fnz"};